import React from "react";
import { DialogTitle, Grid, IconButton, Typography, useTheme } from "@mui/material";
import { Close } from "@mui/icons-material";

const ModalHeader = (props) => {
  const { title, handleClose } = props;
  const theme = useTheme();

  const displayTitle =
    typeof title === "string" ? (
      <Typography variant="h4">{title}</Typography>
    ) : (
      title
    );

  return (
    <DialogTitle
      sx={{
        background: theme.branding.gray[0],
        position: "sticky",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
      }}
    >
      <Grid
        container
        justify={displayTitle ? "space-between" : "flex-end"}
        alignItems="center"
        wrap="nowrap"
      >
        {displayTitle && <Grid>{displayTitle}</Grid>}
        <Grid>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Grid>
      </Grid>
    </DialogTitle>
  );
};

export default ModalHeader;
